import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

export function RowActionButton({ children, onClick, disabled = false, variant = 'onyxPrimary' }) {
  return (
    <Button
      size="small"
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      data-testid="onyx-row-action"
    >
      {children}
    </Button>
  );
}

RowActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
};
